import { axios } from '@Root/API'

export const edit = (qualificationAwardId, payload) => {
	return axios.put(`qualification-awarded/${qualificationAwardId}/accreditation/${payload.id}`, payload)
}
